export const getTranslation = async (key: string) => {
  return await import(`./${LOCALE}/${key}.json`)
}

// TODOl support multiple locales
const LOCALE = 'ja'